import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmlAutocompleteControlComponent } from './cml-autocomplete-control.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';



@NgModule({
  declarations: [
    CmlAutocompleteControlComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    CmlAutocompleteControlComponent
  ]
})
export class CmlAutocompleteControlModule { }
